import React from "react";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import {GetUserToken} from "../../../api/token";
import PluginAddDeleteList from "../../../components/General/PluginAddDeleteList";
import {PostToPbx} from "../../../api/http-post";
import {formatDateTime, LoadDataAnyEndpoint} from "../../../api/fn";
import moment from "moment";
import {fetchDataEntity} from "../../../api/entity-data";
import GenericComboBox from "../../../components/General/GenericComboBox";
import {Col, PageHeader, Row, Button, List, Skeleton, Avatar, Modal} from "antd";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import NewLeadDrawer from "../../../components/Common/workboard/NewLeadDrawer";
import {ExclamationCircleOutlined, PhoneFilled} from "@ant-design/icons";
import {doCall, doHangup} from "../../../webcall/JanusSipCall";
import AlertBox from "../../../webcall/AlertBox";

const { confirm } = Modal;

class WorkboardLeadPage2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Projects: [],
            Modules: [],
            Products: [],
            selectedCompany: "",
            selectedModule: '',
            isLoading: false,
            component: "list",
            newEntry: {},
            Users: [],
            UserProjects: [],
            showActionLead:false,
        }
    }


    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("UserProjects", "", "", this, undefined, "common/entity/AllocationUserProject/list");

        await this.loadInitialData();
        await this.loadUsers();
    }
    loadInitialData = async () => {
        await fetchDataEntity("Data", "", "", this, undefined, "common/entity/Callbacks/list");
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    handleChangeCompany = async (val, key) => {
        this.setState({
            [key]: val,
        });
    }
    makeCall=async (item)=>{
        if(!window.confirm("Are you sure to make this call: "+item.phone)){
            return
        }
        await  this.dialRequest(item.phone)

    }
    submitCloseCallback=async (rowIn)=>{
        let _this = this;
        let userInfo = GetUserToken();
        let hub = {};
        hub.Data = rowIn;
        hub.Agent = userInfo.Username;
        hub.State = "close"
        let endpoint = "/desk/callback/action/update-complete";
        await PostToPbx(hub, endpoint, async (data) => {
            await _this.loadInitialData()
             alert("Thank you , callback updated!")
        });
    }
    closeLead=(ItemRow)=>{
            let _this=this;
            confirm({
                title: 'Do you Want to Close this callback?',
                icon: <ExclamationCircleOutlined />,
                content: <div>
                    <p>Customer: {ItemRow.contactperson}</p>
                    <p>Subject: {ItemRow.subject}</p>
                    <p>Message: {ItemRow.message}</p>
                    <p>Created: {formatDateTime(ItemRow.date, ItemRow.time)}</p>
                </div>,
                async onOk() {
                    console.log('OK');
                    await _this.submitCloseCallback(ItemRow)
                },
                onCancel() {
                    console.log('Cancel');
                },
            })
    }
    requestViewMore=(item)=>{
        alert("requestViewMore")
    }
    openNewLeadDrawer=()=>{
        this.setState({
            showActionLead: true,
        })
    }
    getInfo = () => {
        let userInfo = GetUserToken();
        let extension = "", project = "", name = userInfo.FullName, email = userInfo.Username, phone = userInfo.Phone,
            org = userInfo.Org,role=userInfo.Role;
        for (let i in this.state.UserProjects) {
            let row = this.state.UserProjects[i];
            if (row.user === userInfo.Username) {
                project = row.project;
            }
        }
        for (let i in this.state.UserVoips) {
            let row = this.state.UserVoips[i];
            if (row.user === userInfo.Username) {
                extension = row.extension;
            }
        }

        return {extension, project, name, email, phone, org,role}

    }
    getUsers = () => {
        let ls = [];
        let {org}=this.getInfo();
        for (let i in this.state.Users) {
            let row = this.state.Users[i];
            if (row.Org !== org) {
                continue
            }
            ls.push({
                key: row.Username,
                val: row.FullName,
            })
        }
        return ls
    }
    getReason = () => {

        return [
            {key: "Assistance", val: "Assistance"},
            {key: "Police", val: "Police"},
            {key: "Hospital", val: "Hospital"},
        ]
    }

    /**
     * Call outbound browser number
     * @returns {*}
     */
    submitCallLog = async (phone, ref) => {
        let hub = {
            Org: this.state.currentOrg,
            Agent: this.state.currentAgent,
            Ref: "admin-outbound",
            Phone: phone,
            CallRef: this.props.pbx.Extension.username
        }
        let endpoint = "/lead/entity/insert/batch-agent-call";
        await this.PostState(hub, endpoint, "fakeCallLogSubmit");
    }
    dialRequest = async (phone) => {
        console.log("dialRequest--> ", phone);
        const regStatus = this.props.pbx.Registry.status;
        if (regStatus === "Not registered") {
            return alert("Sorry you can't make without register first, click on the online switch!")
        }

        if (this.state.isDialing) {
            return alert("Please wait while another call in progress!");
        }
        if (phone === "") {
            return alert("Please provide number to call!");
        }
        if (!this.isValidNumber(phone)) {
            return alert("Error your number is not valid! 10 digit required")
        }
        let destination = "27" + phone.substring(phone.length - 9);
        //destination = destination.substring(destination.length - 9);

        doCall({
            to: destination,
            host: this.props.pbx.Server.host,
            AlertBox: AlertBox,
            isVideoCall: false
        });
        //this.props.PbxOutCallShowForm({isSet:true})
        this.setState({
            dialingNumber: phone
        });

        await this.submitCallLog(phone)

    }
    stop = () => {
        doHangup();
        this.props.PbxOutCallEnd({is: true})
    }
    isValidNumber = (num) => {
        let str = num;
        let pattern = new RegExp("^[0-9]{10}$");
        let result = pattern.test(str);
        console.log("isValidNumber -> ", str, " > ", result, " > ", /^\d{10}$/.test(str));
        return true
    }
    renderHangup = () => {
        let props = this.props;
        let pbxCalling = props.pbx.Calling;
        let dialStatus = false;
        if (pbxCalling.status !== "Not registered") {
            dialStatus = true
        }

        let _this = this;
        if (pbxCalling.status === "Not registered" || pbxCalling.status === "hangup") {
            return null
        }
        return (
            <a
                style={{cursor: "pointer", color: "red", marginLeft: 20}}
                onClick={() => _this.stop()}
            >
                <PhoneFilled/>
            </a>
        )
    }
    PostState = async (hub, endpoint, stateKey) => {
        let _this = this;
        this.setState({
            isLoading: true
        })
        await PostToPbx(hub, endpoint, async (dataIn) => {
            if(dataIn===null){
                _this.setState({
                    [stateKey]: [],
                    isLoading: false
                })
                return
            }
            const data = dataIn.RESULT;

            console.log(endpoint + " response ---> ", data, dataIn);
            _this.setState({
                [stateKey]: data,
                isLoading: false
            })
        });
    }
    /**
     * End of functions
     */

    renderProjectSelection = () => {

        let data = [];
        let company = this.state.selectedCompany;
        for (let i in this.state.Projects) {
            let row = this.state.Projects[i];
            console.log("&&&&--isMo> ", company, " > ", row.org)
            if (company === row.org) {
                data.push(row)
            }
        }
        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={data}
                label={"Select Project"}
                name={"selectedProject"}
                message={"Please select your project!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedProject}
                recordOptionKey={"name"}
                recordOptionValue={"name"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderCompaniesSelection = () => {

        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={this.state.Companies}
                label={"Select Company"}
                name={"selectedCompany"}
                message={"Please select your company!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedCompany}
                recordOptionKey={"customernumber"}
                recordOptionValue={"customernumber"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderGlobalFilter = () => {
        let userInfo = GetUserToken();
        if (userInfo.Role !== "super") {
            return null
        }
        return (
            <Row style={{margin: 10}}>
                <Col span={12}>
                    {this.renderCompaniesSelection()}
                </Col>
                <Col span={12}>
                    {this.renderProjectSelection()}
                </Col>
            </Row>
        )
    }
    renderList = () => {
        let ls=[];
        let {org,project,role}=this.getInfo();
        if(role==="super"){
            org = this.state.selectedProject;
            project=this.state.selectedProject;
        }
        for(let i in this.state.Data){
            let row = this.state.Data[i];
            if(row.state==="close"){continue}
            if(row.org !==org||row.module!==project){
                ls.push(row)
            }
        }
        return (
            <List
                className="demo-loadmore-list"
                itemLayout="horizontal"
                dataSource={ls}
                renderItem={item => (
                    <List.Item
                        actions={[
                            <a key="list-loadmore-edit" onClick={()=>this.makeCall(item)}>Call</a>,
                            <a key="list-loadmore-edit" onClick={()=>this.closeLead(item)}>Close</a>,
                        ]}
                    >
                        <Skeleton avatar title={false} loading={item.loading} active>
                            <List.Item.Meta
                                avatar={
                                    <Avatar
                                        src="https://www.startpage.com/av/proxy-image?piurl=https%3A%2F%2Fcdn2.iconfinder.com%2Fdata%2Ficons%2Finstagram-ui%2F48%2Fjee-74-512.png&sp=1607435819T1e8d4ca58b8e5351ae3f9867c2f7fd235e526d729156530a6ef04f4dfdd65fe0"/>
                                }
                                title={<a onClick={()=>this.requestViewMore(item)}>{item.contactperson} ({item.phone})</a>}
                                description={
                                    <div>

                                        <span style={{fontSize: 11, color: "blue"}}>
                                            Subject:{item.subject} &nbsp;|&nbsp;
                                            Message: {item.message}
                                        </span>

                                    </div>
                                }
                            />

                        </Skeleton>
                    </List.Item>
                )}
            />
        )
    }

    render() {
        let props = this.props;
        let pbxCalling = props.pbx.Calling;
        let dialStatus = false;
        if (pbxCalling.status !== "Not registered") {
            dialStatus = true
        }
        const regStatus = this.props.pbx.Registry.status;
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <div style={styles.radiusMe}>
                        <PageHeader
                            info={this.getInfo()}
                            className="site-page-header"
                            onBack={() => window.history.back()}
                            title={"Lead"}
                            subTitle="Desk management system"
                            extra={[
                                <Button
                                    type="dashed"
                                    icon={<PlusOutlined/>}
                                    style={{
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        margin: 10,
                                    }}
                                    onClick={() => this.openNewLeadDrawer()}
                                >
                                    New Lead
                                </Button>,
                            ]}
                        >
                        </PageHeader>
                    </div>
                    <div>
                        {dialStatus ?
                            <React.Fragment>
                                                <span
                                                    style={{color: "#9c27b0",fontSize:24}}
                                                >
                                                    Call Status :{pbxCalling.status} {this.renderHangup()}
                                                </span>
                            </React.Fragment> : null}
                    </div>
                    <div style={{minWidth: "100%", padding: 10}}>

                        {this.renderList()}
                    </div>
                    <NewLeadDrawer _this={this} />
                </div>
            </Page>
        )
    }

}

export default Connector(WorkboardLeadPage2);


const styles = {
    radiusMe: {
        border: "1px solid red",
        borderRadius: 5,
    },
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
}


